export default __webpack_public_path__ + "static/media/patient_selected.f582692c.svg";